import { useMutation } from "@tanstack/react-query";
import { z } from "zod";
import { useToast } from "@/components/ui/use-toast";
import { fetchApi } from "@/lib/api";

export const aiTraitsSchema = z.object({
  mentorshipId: z.string(),
  traits: z.string(),
});

export type AITraitsSchema = z.infer<typeof aiTraitsSchema>;

export function useAITraitsMutation() {
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (data: AITraitsSchema) => {
      const response = await fetchApi({
        url: `/v1/mentorships/${data.mentorshipId}/ai-traits`,
        method: "PUT",
        data: {
          traits: data.traits,
        },
      });

      return response.data;
    },
    onSuccess: () => {
      toast({
        title: "AI reply traits saved successfully!",
      });
    },
    onError: (error) => {
      console.error("Error updating AI traits:", error);
      toast({
        title: "Failed to save AI reply traits",
        description: error.message,
        variant: "destructive",
      });
    },
  });
}
